<template>
  <div>
    <slot
      v-bind="{
        members,
        page,
        lastPage,
        next
      }"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TeamMemberPaginator',
  props: {
    teamId: {
      type: String,
      required: true
    },
    perPage: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      members: [],
      page: 1,
      lastPage: 1
    }
  },
  watch: {
    teamId() {
      this.members = []
      this.page = 1
      this.fetch(1)
    },
    page(page) {
      this.fetch(page)
    }
  },
  mounted() {
    this.fetch(this.page)
  },
  methods: {
    ...mapActions([
      'getTeamMembers'
    ]),
    async fetch(page) {
      const { data: male, meta: { lastPage: lastPageMale } } = await this.getTeamMembers({
        id: this.teamId,
        page,
        perPage: this.perPage,
        gender: 'm'
      })

      const { data: female, meta: { lastPage: lastPageFemale } } = await this.getTeamMembers({
        id: this.teamId,
        page,
        perPage: this.perPage,
        gender: 'f'
      })

      this.lastPage = Math.max(lastPageMale, lastPageFemale)
      if (page > 1) {
        this.members = this.members.concat(male, female)
      } else {
        this.members = [...male, ...female]
      }
    },
    next() {
      this.page += 1
    }
  }
}
</script>

<style lang="scss">

</style>
